import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.guide03.delivery-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  accordionItem3Title: {
    id: `${PREFIX}.accordion-item3.title`,
  },
  accordionItem3Description: {
    id: `${PREFIX}.accordion-item3.description`,
  },
  accordionItem4Title: {
    id: `${PREFIX}.accordion-item4.title`,
  },
  accordionItem4Description: {
    id: `${PREFIX}.accordion-item4.description`,
  },
  accordionItem5Title: {
    id: `${PREFIX}.accordion-item5.title`,
  },
  accordionItem5Description: {
    id: `${PREFIX}.accordion-item5.description`,
  },
  masterFileTitle: {
    id: `${PREFIX}.master-file.title`,
  },
  masterFileDescription1: {
    id: `${PREFIX}.master-file.description1`,
  },
  masterFileDescription2: {
    id: `${PREFIX}.master-file.description2`,
  },
  masterFileDescription3: {
    id: `${PREFIX}.master-file.description3`,
  },
  masterFileDescription4: {
    id: `${PREFIX}.master-file.description4`,
  },
  masterFileDescription5: {
    id: `${PREFIX}.master-file.description5`,
  },
  admTitle: {
    id: `${PREFIX}.adm.title`,
  },
  admDescription1: {
    id: `${PREFIX}.adm.description1`,
  },
  admDescription2: {
    id: `${PREFIX}.adm.description2`,
  },
  admDescription3: {
    id: `${PREFIX}.adm.description3`,
  },
  admDescription4: {
    id: `${PREFIX}.adm.description4`,
  },
  imfTitle: {
    id: `${PREFIX}.imf.title`,
  },
  imfDescription1: {
    id: `${PREFIX}.imf.description1`,
  },
  digitalCinemaTitle: {
    id: `${PREFIX}.digital-cinema.title`,
  },
  digitalCinemaDescription1: {
    id: `${PREFIX}.digital-cinema.description1`,
  },
  qualityControlTitle: {
    id: `${PREFIX}.quality-control.title`,
  },
  qualityControlDescription1: {
    id: `${PREFIX}.quality-control.description1`,
  },
});
